module.exports = __webpack_public_path__ + "img/icon-loading.b9b45bc8.svg";